import { apiFetch } from "../api";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState, useRef } from "react";
import { Scanner } from "@yudiel/react-qr-scanner";

import { useI18n } from "../i18n/I18nContext";

const LIME    = "#E6FF3E";
const DARK    = "#010F14";
const PANEL   = "#012836";
const GREEN   = "#00B050";
const RED     = "#C00000";
const BORDER  = "#1a4a5a";

export default function TracabilitePli() {
  const { t, ui } = useI18n();

  const navigate = useNavigate();

  const [operator, setOperator]         = useState("");
  const [pns, setPns]                   = useState([]);
  const [pn, setPn]                     = useState("");
  const [pnSearch, setPnSearch]         = useState("");
  const [showPnList, setShowPnList]     = useState(false);
  const [plisDebutBatch, setPlisDebutBatch] = useState("");
  const [plisFinBatch, setPlisFinBatch]     = useState("");
  const [qtyRebus, setQtyRebus]             = useState("");
  const [commentRebus, setCommentRebus]     = useState("");
  const [qtySimpleNok, setQtySimpleNok]     = useState("");
  const [commentSimpleNok, setCommentSimpleNok] = useState("");
  const [commentGlobal, setCommentGlobal]   = useState("");
  const [now, setNow]                   = useState(new Date());
  const [loadingPn, setLoadingPn]       = useState(false);
  const [sending, setSending]           = useState(false);
  const [error, setError]               = useState("");
  const [success, setSuccess]           = useState("");
  const pnBoxRef                        = useRef(null);
  const [isScannerOpen, setIsScannerOpen] = useState(false);
  const [repartitionClasses, setRepartitionClasses] = useState(null);

  useEffect(() => {
    const raw = localStorage.getItem("user");
    if (raw) {
      try { setOperator(JSON.parse(raw).username || ""); }
      catch (e) { console.error(e); }
    }
  }, []);

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);
useEffect(() => {
  if (!pn) return;

  // Récupère le prochain début de batch
  apiFetch(`/api/production/tracabilite-pli/next-batch?pn=${encodeURIComponent(pn)}`)
    .then((r) => r.json())
    .then((data) => {
      if (data.status === "success") setPlisDebutBatch(String(data.next_debut_batch));
    })
    .catch(console.error);

  // ← Calcul automatique des classes dès la sélection du PN
  setRepartitionClasses(null);
  apiFetch(`/api/production/tracabilite-pli/classes?pn=${encodeURIComponent(pn)}`)
    .then((r) => r.json())
    .then((data) => {
      if (data.status === "success") setRepartitionClasses(data.repartition_classes);
    })
    .catch(console.error);


}, [pn]);

  useEffect(() => {
    function handleClickOutside(e) {
      if (pnBoxRef.current && !pnBoxRef.current.contains(e.target)) setShowPnList(false);
    }
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    async function loadPn() {
      setLoadingPn(true);
      try {
        const res  = await apiFetch("/api/list");
        if (!res.ok) throw new Error();
        const data = await res.json();
        const allPn = Array.isArray(data) ? data.map((i) => i.PN || i.pn).filter(Boolean) : [];
        setPns(Array.from(new Set(allPn)));
      } catch { setError("Impossible de charger la liste des PN."); }
      finally { setLoadingPn(false); }
    }
    loadPn();
  }, []);

  async function handleSubmit(e) {
    e.preventDefault();
    setError(""); setSuccess("");
    if (!pn) { setError("Merci de renseigner un PN."); return; }

    const payload = {
      operator, pn,
      plisDebutBatch : Number(plisDebutBatch) || 0,
      plisFinBatch   : Number(plisFinBatch)   || 0,
      qtyRebus       : Number(qtyRebus)       || 0,
      commentRebus   : commentRebus   || "",
      qtySimpleNok   : Number(qtySimpleNok)   || 0,
      commentSimpleNok: commentSimpleNok || "",
      commentGlobal  : commentGlobal  || "",
      timestamp      : new Date().toISOString(),
    };

    try {
      setSending(true);
      const res = await apiFetch("/api/production/tracabilite-pli", {
        method : "POST",
        headers: { "Content-Type": "application/json" },
        body   : JSON.stringify(payload),
      });
      if (!res.ok) { const d = await res.json().catch(() => ({})); throw new Error(d.message || "Erreur serveur"); }
      const out = await res.json();
      console.log("REPONSE TRACABILITE =", out);
      setSuccess("✅ Données enregistrées avec succès.");
      setRepartitionClasses(out.repartition_classes || null);
      setPlisDebutBatch(String(out.next_debut_batch ?? ""));
      setPlisFinBatch(""); setQtyRebus(""); setCommentRebus("");
      setQtySimpleNok(""); setCommentSimpleNok(""); setCommentGlobal("");
    } catch (err) { setError("❌ " + (err.message || "Erreur lors de l'envoi.")); }
    finally { setSending(false); }
  }

  function normalizeText(text) {
    return text.toString().toLowerCase().normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, " ").trim();
  }

  const filteredPns = pns.filter((p) => {
    const s = normalizeText(pnSearch);
    return !s || normalizeText(p).includes(s);
  });

  const timeStr  = now.toLocaleTimeString("fr-FR");
  const dateStr  = now.toLocaleDateString("fr-FR", { weekday: "short", day: "2-digit", month: "short", year: "numeric" });

  return (
    <div className="tp-page">

      {/* ── SCANNER MODAL ── */}
      {isScannerOpen && (
        <div className="tp-modal-backdrop">
          <div className="tp-modal-scanner">
            <div className="tp-modal-title">📷 Scanner un QR code PN</div>
            <div style={{ borderRadius: 10, overflow: "hidden" }}>
              <Scanner
                onScan={(codes) => {
                  const text = codes?.[0]?.rawValue;
                  if (!text) return;
                  setPn(text); setPnSearch(text); setShowPnList(false); setIsScannerOpen(false);
                }}
                onError={(e) => console.error("QR:", e)}
              />
            </div>
            <button className="tp-btn-close-scanner" onClick={() => setIsScannerOpen(false)}>✕ Fermer</button>
          </div>
        </div>
      )}

      {/* ── CARTE PRINCIPALE ── */}
      <div className="tp-card">

        {/* titre */}
        <div className="tp-header">
          <span>Traçabilité Pli</span>
          <span className="tp-header-sub">Classification / Tri</span>
        </div>

        {/* nav */}
        <div className="tp-nav">
          <button type="button" className="tp-btn-back" onClick={() => navigate("/menu")}>← Retour menu</button>
          <div className="tp-clock">
            <div className="tp-clock-time">{timeStr}</div>
            <div className="tp-clock-date">{dateStr}</div>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="tp-form">

          {/* opérateur */}
          <div className="tp-operator-badge">
            <span className="tp-operator-dot" />
            {operator ? operator.toUpperCase() : "OPÉRATEUR NON CONNECTÉ"}
          </div>

          {/* PN */}
          <div className="tp-section">
            <div className="tp-section-label">🔖 Numéro de lot (PN)</div>
            <div ref={pnBoxRef} style={{ position: "relative" }}>
              <div className="tp-pn-row">
                <input
                  className="tp-pn-input"
                  value={pnSearch}
                  onChange={(e) => { setPnSearch(e.target.value); setShowPnList(true); }}
                  onFocus={() => setShowPnList(true)}
                  placeholder={loadingPn ? "Chargement…" : "Filtrer ou saisir un PN"}
                  disabled={loadingPn}
                />
                <button type="button" className="tp-scan-btn" onClick={() => setIsScannerOpen(true)} title="Scanner QR">
                  📷
                </button>
              </div>


                 {repartitionClasses && (() => {
  const nbEmpPossible = Math.min(
    Math.floor(repartitionClasses.HIGH   / 2),
    Math.floor(repartitionClasses.MEDIUM / 8),
    Math.floor(repartitionClasses.LOW    / 4),
  );
  const facteur = [
    { label: "HAUTE",   besoin: 2, dispo: repartitionClasses.HIGH   },
    { label: "MEDIUM", besoin: 8, dispo: repartitionClasses.MEDIUM },
    { label: "BASSE",    besoin: 4, dispo: repartitionClasses.LOW    },
  ];
  const limitant = facteur.reduce((a, b) =>
    Math.floor(a.dispo / a.besoin) <= Math.floor(b.dispo / b.besoin) ? a : b
  );
  const manquant = (nbEmpPossible + 1) * limitant.besoin - limitant.dispo;

  return (
    <div className="tp-section" style={{ gap: 16 }}>

      {/* ── Titre ── */}
      <div className="tp-section-label">📊 Analyse densité du lot</div>

      {/* ── Classes densité ── */}
      <div style={{ fontSize: 10, color: "#5a8a99", fontWeight: 700, letterSpacing: "0.08em", marginBottom: -8 }}>
        RÉPARTITION PAR CLASSE — {repartitionClasses.total} plis mesurés
      </div>

      <div className="tp-classes-grid">
        {[
          { label: "HAUTE",   desc: "Densité haute",   color: "#E6FF3E", bg: "#0d1a00", border: "#4a6600", count: repartitionClasses.HIGH,   besoin: 2 },
          { label: "MEDIUM", desc: "Densité moyenne",  color: "#7ab8cc", bg: "#001829", border: "#1a5a6a", count: repartitionClasses.MEDIUM, besoin: 8 },
          { label: "BASSE",    desc: "Densité basse",    color: "#ff9090", bg: "#1a0000", border: "#6a1a1a", count: repartitionClasses.LOW,    besoin: 4 },
        ].map(({ label, desc, color, bg, border, count, besoin }) => {
          const pct = repartitionClasses.total > 0
            ? ((count / repartitionClasses.total) * 100).toFixed(1) : "0.0";
          const empMax = Math.floor(count / besoin);
          return (
            <div key={label} style={{
              background: bg, border: `1px solid ${border}`,
              borderRadius: 12, padding: "14px 12px",
              display: "flex", flexDirection: "column", alignItems: "center", gap: 5,
            }}>
              {/* label + desc */}
              <span style={{ color, fontSize: 12, fontWeight: 900, letterSpacing: "0.1em" }}>{label}</span>
              <span style={{ color: "#3a6a7a", fontSize: 9, fontWeight: 600, textAlign: "center" }}>{desc}</span>

              {/* nombre de plis */}
              <span style={{ color: "#fff", fontSize: 28, fontWeight: 900, lineHeight: 1, margin: "4px 0" }}>{count}</span>

              {/* pourcentage */}
              <span style={{ color, fontSize: 11, fontWeight: 700 }}>{pct}%</span>

              {/* barre */}
              <div style={{ width: "100%", height: 4, background: "#1a3a4a", borderRadius: 2, margin: "2px 0" }}>
                <div style={{ width: `${pct}%`, height: "100%", background: color, borderRadius: 2, transition: "width 0.5s ease" }} />
              </div>

              {/* besoin par emp */}
              <div style={{
                marginTop: 4, width: "100%",
                background: "rgba(255,255,255,0.04)", borderRadius: 6, padding: "5px 8px",
                display: "flex", justifyContent: "space-between", alignItems: "center",
              }}>
                <span style={{ color: "#3a6a7a", fontSize: 9, fontWeight: 600 }}>{besoin} / empilement</span>
                <span style={{ color, fontSize: 9, fontWeight: 800 }}>→ {empMax} emp max</span>
              </div>
            </div>
          );
        })}
      </div>

      {/* ── Séparateur ── */}
      <div style={{ height: 1, background: "linear-gradient(90deg, transparent, #1a4a5a, transparent)" }} />

      {/* ── Compteurs ── */}
      <div style={{ fontSize: 10, color: "#5a8a99", fontWeight: 700, letterSpacing: "0.08em", marginBottom: -8 }}>
        BILAN EMPILEMENTS (14 plis · 2H + 8M + 4L)
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10 }}>
        {[
          {
            label: "POSSIBLES",
            sub: "selon le lot",
            value: repartitionClasses.nb_emp_possible,
            color: "#E6FF3E", bg: "#0d1a00", border: "#4a6600",
            icon: "📦",
          },
          {
            label: "DÉJÀ FAITS",
            sub: "depuis ce lot",
            value: repartitionClasses.nb_emp_deja_faits,
            color: "#ff9090", bg: "#1a0000", border: "#6a1a1a",
            icon: "✅",
          },
          {
            label: "DISPONIBLES",
            sub: "restants à faire",
            value: repartitionClasses.nb_emp_disponible,
            color: "#7aff9a", bg: "#001a0a", border: "#1a6a3a",
            icon: "⚡",
          },
        ].map(({ label, sub, value, color, bg, border, icon }) => (
          <div key={label} style={{
            background: bg, border: `2px solid ${border}`,
            borderRadius: 12, padding: "14px 10px",
            display: "flex", flexDirection: "column", alignItems: "center", gap: 4,
          }}>
            <span style={{ fontSize: 16 }}>{icon}</span>
            <span style={{ color: "#5a8a99", fontSize: 9, fontWeight: 800, letterSpacing: "0.08em", textAlign: "center" }}>
              {label}
            </span>
            <span style={{ color, fontSize: 34, fontWeight: 900, lineHeight: 1, margin: "4px 0" }}>
              {value}
            </span>
            <span style={{ color: "#3a6a7a", fontSize: 9, fontWeight: 600 }}>{sub}</span>
          </div>
        ))}
      </div>

      {/* ── Facteur limitant ── */}
      <div style={{
        background: "#0a0a0a", border: "1px solid #2a2a2a",
        borderRadius: 10, padding: "12px 16px",
        display: "flex", flexDirection: "column", gap: 8,
      }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span style={{ color: "#5a8a99", fontSize: 10, fontWeight: 800, letterSpacing: "0.08em" }}>
            ⚠ FACTEUR LIMITANT
          </span>
          <span style={{
            color: "#ff9090", fontSize: 11, fontWeight: 800,
            background: "#2a0808", border: "1px solid #ff6b6b",
            borderRadius: 6, padding: "3px 10px",
          }}>
            {limitant.label} — {limitant.dispo} plis dispo / {limitant.besoin} requis par emp
          </span>
        </div>
        <div style={{
          background: "#111", borderRadius: 8, padding: "8px 12px",
          display: "flex", justifyContent: "space-between", alignItems: "center",
        }}>
          <span style={{ color: "#5a8a99", fontSize: 10 }}>
            Pour atteindre <strong style={{ color: "#fff" }}>{nbEmpPossible + 1} empilements</strong>
          </span>
          <span style={{
            color: "#ffd060", fontSize: 11, fontWeight: 800,
            background: "#1a1000", border: "1px solid #6a5000",
            borderRadius: 6, padding: "3px 10px",
          }}>
            + {manquant} plis {limitant.label} nécessaires
          </span>
        </div>
      </div>

    </div>
  );
})()}

              {/* selected PN pill */}
              {pn && (
                <div className="tp-pn-selected">
                  <span>✔ Sélectionné :</span>
                  <strong>{pn}</strong>
                  <button type="button" className="tp-pn-clear"
                    onClick={() => { setPn(""); setPnSearch(""); setPlisDebutBatch("");setRepartitionClasses(null); }}>✕</button>
                </div>
              )}

              {showPnList && filteredPns.length > 0 && (
                <div className="tp-dropdown" onMouseDown={(e) => e.preventDefault()}>
                  {filteredPns.map((p) => (
                    <div key={p} className="tp-dropdown-item"
                      onClick={() => { setPn(p); setPnSearch(p); setShowPnList(false); }}>
                      {p}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* batch */}
          <div className="tp-section">
            <div className="tp-section-label">📦 Batch</div>
            <div className="tp-grid-2">
              <div className="tp-field">
                <label className="tp-field-label">Début du batch</label>
                <input
                  type="number" min="0"
                  value={plisDebutBatch}
                  readOnly
                  className="tp-input tp-input-readonly"
                  title="Calculé automatiquement"
                />
                <span className="tp-field-hint">Auto-calculé</span>
              </div>
              <div className="tp-field">
                <label className="tp-field-label">Fin du batch</label>
                <input
                  type="number" min="0"
                  value={plisFinBatch}
                  onChange={(e) => setPlisFinBatch(e.target.value)}
                  className="tp-input"
                  placeholder="0"
                />
              </div>
            </div>
          </div>

          {/* rebus */}
          <div className="tp-section tp-section-danger">
            <div className="tp-section-label">🔴 Plis Rebus</div>
            <div className="tp-grid-2">
              <div className="tp-field">
                <label className="tp-field-label">Quantité</label>
                <input type="number" min="0" value={qtyRebus}
                  onChange={(e) => setQtyRebus(e.target.value)}
                  className="tp-input" placeholder="0" />
              </div>
              <div className="tp-field">
                <label className="tp-field-label">Commentaire</label>
                <textarea rows={3} value={commentRebus}
                  onChange={(e) => setCommentRebus(e.target.value)}
                  className="tp-textarea" placeholder="Motif rebus…" />
              </div>
            </div>
          </div>

          {/* NOK */}
          <div className="tp-section tp-section-warning">
            <div className="tp-section-label">🟡 Plis NOK</div>
            <div className="tp-grid-2">
              <div className="tp-field">
                <label className="tp-field-label">Quantité</label>
                <input type="number" min="0" value={qtySimpleNok}
                  onChange={(e) => setQtySimpleNok(e.target.value)}
                  className="tp-input" placeholder="0" />
              </div>
              <div className="tp-field">
                <label className="tp-field-label">Commentaire</label>
                <textarea rows={3} value={commentSimpleNok}
                  onChange={(e) => setCommentSimpleNok(e.target.value)}
                  className="tp-textarea" placeholder="Motif NOK…" />
              </div>
            </div>
          </div>

          {/* commentaire global */}
          <div className="tp-section">
            <div className="tp-section-label">💬 Commentaire global</div>
            <textarea rows={3} value={commentGlobal}
              onChange={(e) => setCommentGlobal(e.target.value)}
              className="tp-textarea" placeholder="Observations générales…" />
          </div>



          {/* messages */}
          {error   && <div className="tp-msg tp-msg-error">{error}</div>}
          {success && <div className="tp-msg tp-msg-success">{success}</div>}

          {/* submit */}
          <button type="submit" disabled={sending} className="tp-btn-submit">
            {sending ? "⏳ Envoi en cours…" : "✔ Confirmer et envoyer"}
          </button>

        </form>
      </div>

      {/* ── STYLES ── */}
      <Style />
    </div>
  );
}

/* ── STYLE COMPONENT ── */
function Style() {
  return (
    <style>{`
      /* ── BASE ── */
      *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

      .tp-page {
        min-height: 100vh;
        width: 100%;
        background: radial-gradient(ellipse at top, #01283a 0%, #010F14 70%);
        display: flex;
        justify-content: center;
        align-items: flex-start;
        padding: 16px;
        font-family: 'Inter', 'Segoe UI', sans-serif;
      }
      
      .tp-classes-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 10px;
}

      .tp-card {
        width: 100%;
        max-width: 640px;
        background: #011e2b;
        border: 1px solid #1a4a5a;
        border-radius: 16px;
        overflow: hidden;
        box-shadow: 0 8px 40px rgba(0,0,0,0.6), 0 0 0 1px #0a3040;
      }

      /* ── HEADER ── */
      .tp-header {
        background: linear-gradient(135deg, #E6FF3E 0%, #c8e800 100%);
        color: #000;
        padding: 14px 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 2px;
      }
      .tp-header span { font-size: 15px; font-weight: 800; text-transform: uppercase; letter-spacing: 0.1em; }
      .tp-header-sub  { font-size: 11px; font-weight: 500; opacity: 0.6; letter-spacing: 0.05em; }

      /* ── NAV ── */
      .tp-nav {
        background: #010f14;
        padding: 8px 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #1a4a5a;
      }
      .tp-btn-back {
        background: transparent;
        color: #7ab8cc;
        border: 1px solid #1a4a5a;
        border-radius: 6px;
        padding: 5px 10px;
        font-size: 11px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s;
      }
      .tp-btn-back:hover { background: #1a4a5a; color: #fff; }

      .tp-clock { text-align: right; }
      .tp-clock-time { color: #E6FF3E; font-size: 15px; font-weight: 700; font-variant-numeric: tabular-nums; }
      .tp-clock-date { color: #5a8a99; font-size: 10px; }

      /* ── FORM ── */
      .tp-form {
        padding: 20px;
        display: flex;
        flex-direction: column;
        gap: 20px;
      }

      /* ── OPÉRATEUR ── */
      .tp-operator-badge {
        display: flex;
        align-items: center;
        gap: 10px;
        background: linear-gradient(90deg, #012836, #013d50);
        border: 1px solid #1a5a6a;
        border-radius: 10px;
        padding: 12px 16px;
        color: #fff;
        font-size: 14px;
        font-weight: 700;
        letter-spacing: 0.06em;
      }
      .tp-operator-dot {
        width: 10px; height: 10px;
        background: #00B050;
        border-radius: 50%;
        box-shadow: 0 0 6px #00B050;
        flex-shrink: 0;
      }

      /* ── SECTION ── */
      .tp-section {
        background: #012030;
        border: 1px solid #1a4a5a;
        border-radius: 12px;
        padding: 14px 16px;
        display: flex;
        flex-direction: column;
        gap: 12px;
      }
      .tp-section-danger  { border-color: #5a1a1a; background: #1a0808; }
      .tp-section-warning { border-color: #5a4a00; background: #151000; }

      .tp-section-label {
        font-size: 12px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.08em;
        color: #7ab8cc;
      }
      .tp-section-danger  .tp-section-label { color: #ff8080; }
      .tp-section-warning .tp-section-label { color: #ffd060; }

      /* ── GRID ── */
      .tp-grid-2 {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 12px;
      }

      /* ── FIELD ── */
      .tp-field { display: flex; flex-direction: column; gap: 5px; }
      .tp-field-label {
        font-size: 11px;
        font-weight: 600;
        color: #4a8a9a;
        text-transform: uppercase;
        letter-spacing: 0.06em;
      }
      .tp-field-hint { font-size: 10px; color: #3a6a7a; font-style: italic; }

      /* ── INPUTS ── */
      .tp-input {
        width: 100%;
        background: #010F14;
        color: #fff;
        border: 1px solid #1a4a5a;
        border-radius: 8px;
        padding: 10px 14px;
        font-size: 15px;
        text-align: center;
        font-weight: 600;
        transition: border 0.2s, box-shadow 0.2s;
        outline: none;
      }
      .tp-input:focus { border-color: #E6FF3E; box-shadow: 0 0 0 2px rgba(230,255,62,0.15); }
      .tp-input-readonly {
        background: #020d12;
        color: #4a9aaa;
        cursor: not-allowed;
        border-style: dashed;
      }
      .tp-textarea {
        width: 100%;
        background: #1a0e06;
        color: #f0d0b0;
        border: 1px solid #5a3020;
        border-radius: 8px;
        padding: 10px 12px;
        font-size: 13px;
        resize: vertical;
        outline: none;
        transition: border 0.2s;
        font-family: inherit;
      }
      .tp-textarea:focus { border-color: #ff8040; box-shadow: 0 0 0 2px rgba(255,128,64,0.1); }

      /* ── PN ── */
      .tp-pn-row { display: flex; gap: 8px; align-items: center; }
      .tp-pn-input {
        flex: 1;
        background: #003818;
        color: #7aff9a;
        border: 1px solid #005020;
        border-radius: 8px;
        padding: 10px 14px;
        font-size: 14px;
        font-weight: 600;
        text-align: center;
        outline: none;
        transition: border 0.2s;
      }
      .tp-pn-input:focus { border-color: #00B050; box-shadow: 0 0 0 2px rgba(0,176,80,0.15); }
      .tp-scan-btn {
        width: 46px; height: 46px;
        background: #012030;
        border: 1px solid #1a4a5a;
        border-radius: 8px;
        font-size: 20px;
        cursor: pointer;
        transition: background 0.2s;
        flex-shrink: 0;
      }
      .tp-scan-btn:hover { background: #1a4a5a; }

      .tp-pn-selected {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-top: 8px;
        background: #002810;
        border: 1px solid #00B050;
        border-radius: 8px;
        padding: 6px 12px;
        font-size: 12px;
        color: #7aff9a;
      }
      .tp-pn-selected strong { flex: 1; font-size: 13px; }
      .tp-pn-clear {
        background: transparent;
        border: none;
        color: #ff8080;
        cursor: pointer;
        font-size: 14px;
        font-weight: 700;
      }

      .tp-dropdown {
        position: absolute;
        left: 0; right: 0;
        margin-top: 4px;
        max-height: 200px;
        overflow-y: auto;
        background: #002818;
        border: 1px solid #005020;
        border-radius: 8px;
        z-index: 50;
        box-shadow: 0 8px 24px rgba(0,0,0,0.5);
      }
      .tp-dropdown-item {
        padding: 8px 14px;
        color: #aaffcc;
        font-size: 13px;
        cursor: pointer;
        border-bottom: 1px solid #003818;
        transition: background 0.15s;
      }
      .tp-dropdown-item:hover { background: #003d20; }

      /* ── MESSAGES ── */
      .tp-msg {
        border-radius: 8px;
        padding: 10px 14px;
        font-size: 13px;
        font-weight: 600;
      }
      .tp-msg-error   { background: #2a0808; border: 1px solid #C00000; color: #ff9090; }
      .tp-msg-success { background: #002810; border: 1px solid #00B050; color: #80ff90; }

      /* ── SUBMIT ── */
      .tp-btn-submit {
        width: 100%;
        background: linear-gradient(135deg, #00B050, #008a3c);
        color: #000;
        border: none;
        border-radius: 10px;
        padding: 14px;
        font-size: 15px;
        font-weight: 800;
        text-transform: uppercase;
        letter-spacing: 0.08em;
        cursor: pointer;
        transition: opacity 0.2s, transform 0.1s;
        box-shadow: 0 4px 16px rgba(0,176,80,0.3);
      }
      .tp-btn-submit:hover:not(:disabled) { opacity: 0.9; transform: translateY(-1px); }
      .tp-btn-submit:disabled { opacity: 0.5; cursor: not-allowed; }

      /* ── SCANNER MODAL ── */
      .tp-modal-backdrop {
        position: fixed; inset: 0;
        background: rgba(0,0,0,0.8);
        display: flex; justify-content: center; align-items: center;
        z-index: 999;
        backdrop-filter: blur(4px);
      }
      .tp-modal-scanner {
        width: 90%; max-width: 420px;
        background: #011e2b;
        border: 1px solid #00B050;
        border-radius: 14px;
        padding: 16px;
        display: flex; flex-direction: column; gap: 12px;
        box-shadow: 0 0 40px rgba(0,176,80,0.2);
      }
      .tp-modal-title { color: #fff; font-size: 14px; font-weight: 700; text-align: center; }
      .tp-btn-close-scanner {
        background: #C00000;
        color: #fff;
        border: none;
        border-radius: 8px;
        padding: 10px;
        font-weight: 700;
        font-size: 13px;
        cursor: pointer;
        transition: opacity 0.2s;
      }
      .tp-btn-close-scanner:hover { opacity: 0.85; }

      /* ── TABLETTE ── */
      @media (min-width: 768px) {
        .tp-card   { max-width: 720px; }
        .tp-header span { font-size: 17px; }
        .tp-form   { padding: 24px 28px; gap: 22px; }
        .tp-input  { font-size: 16px; padding: 12px 16px; }
        .tp-textarea { font-size: 14px; }
        .tp-section-label { font-size: 13px; }
        .tp-btn-submit { font-size: 16px; padding: 16px; }
      }

      /* ── DESKTOP ── */
      @media (min-width: 1024px) {
        .tp-card   { max-width: 900px; }
        .tp-header { padding: 18px 28px; }
        .tp-header span { font-size: 20px; }
        .tp-form   { padding: 28px 36px; gap: 26px; }
        .tp-input  { font-size: 18px; padding: 14px 18px; }
        .tp-textarea { font-size: 15px; }
        .tp-operator-badge { font-size: 16px; padding: 14px 20px; }
        .tp-section { padding: 18px 20px; }
        .tp-section-label { font-size: 14px; }
        .tp-field-label { font-size: 12px; }
        .tp-btn-submit { font-size: 18px; padding: 18px; }
        .tp-clock-time { font-size: 18px; }
        .tp-pn-input   { font-size: 16px; padding: 12px 18px; }
        .tp-scan-btn   { width: 54px; height: 54px; font-size: 24px; }
      }

      /* ── XXL ── */
      @media (min-width: 1400px) {
        .tp-page   { padding: 32px; }
        .tp-card   { max-width: 1100px; border-radius: 20px; }
        .tp-header { padding: 24px 40px; }
        .tp-header span { font-size: 26px; letter-spacing: 0.14em; }
        .tp-header-sub  { font-size: 14px; }
        .tp-nav    { padding: 12px 28px; }
        .tp-btn-back { font-size: 13px; padding: 7px 14px; }
        .tp-clock-time { font-size: 22px; }
        .tp-clock-date { font-size: 12px; }
        .tp-form   { padding: 36px 48px; gap: 32px; }
        .tp-operator-badge { font-size: 20px; padding: 16px 24px; border-radius: 14px; }
        .tp-operator-dot   { width: 14px; height: 14px; }
        .tp-section { padding: 22px 26px; gap: 16px; border-radius: 16px; }
        .tp-section-label  { font-size: 15px; letter-spacing: 0.1em; }
        .tp-field-label    { font-size: 13px; }
        .tp-field-hint     { font-size: 12px; }
        .tp-input  { font-size: 22px; padding: 16px 20px; border-radius: 10px; }
        .tp-input-readonly { font-size: 22px; }
        .tp-textarea { font-size: 18px; padding: 14px 16px; border-radius: 10px; min-height: 110px; }
        .tp-pn-input { font-size: 20px; padding: 14px 20px; border-radius: 10px; height: 58px; }
        .tp-scan-btn { width: 64px; height: 64px; font-size: 28px; border-radius: 10px; }
        .tp-pn-selected { font-size: 14px; padding: 8px 16px; }
        .tp-pn-selected strong { font-size: 16px; }
        .tp-dropdown-item { font-size: 15px; padding: 10px 18px; }
        .tp-msg    { font-size: 15px; padding: 14px 18px; border-radius: 10px; }
        .tp-btn-submit { font-size: 22px; padding: 22px; border-radius: 14px; letter-spacing: 0.1em; }
        .tp-grid-2 { gap: 20px; }
      }
    `}</style>
  );
}
